import React from 'react';
import styles from './SyncProgress.module.scss';

export interface SyncProgressProps {
  /** Whether a sync operation is actively running */
  active: boolean;
  /** Label describing what's being synced (e.g. "games", "achievements") */
  label?: string;
  /** Optional additional CSS class */
  className?: string;
}

const SyncProgress: React.FC<SyncProgressProps> = ({
  active,
  label = 'data',
  className,
}) => {
  if (!active) return null;

  return (
    <div
      className={`${styles.container} ${className ?? ''}`}
      role="status"
      aria-live="polite"
      aria-label={`Syncing ${label}`}
    >
      <div className={styles.content}>
        <div className={styles.spinner} aria-hidden="true" />
        <div className={styles.text}>
          <p className={styles.title}>Syncing {label}…</p>
          <p className={styles.subtitle}>This may take a moment. You can continue browsing.</p>
        </div>
      </div>
      <div className={styles.progressBar}>
        <div className={styles.progressTrack} />
      </div>
    </div>
  );
};

export default SyncProgress;
